<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background: new 0 0 100 100"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <g>
        <path
          class="st0"
          d="M-70.67,88.27c-9.88,0-17.9,8.01-17.9,17.9c0,14.91,17.9,29.75,17.9,29.75s17.9-14.84,17.9-29.75
			C-52.78,96.28-60.79,88.27-70.67,88.27z M-70.67,113.14c-3.85,0-6.98-3.12-6.98-6.98c0-3.85,3.12-6.98,6.98-6.98
			c3.85,0,6.98,3.12,6.98,6.98C-63.7,110.02-66.82,113.14-70.67,113.14z"
        />
      </g>
    </g>
    <g>
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M154.78-7.02c-13.89,0-25.16,11.26-25.16,25.16c0,4.56,1.22,8.83,3.34,12.51l-3.5,13.06l13.18-3.53
					c3.6,1.99,7.73,3.12,12.14,3.12c13.89,0,25.16-11.26,25.16-25.16C179.94,4.24,168.67-7.02,154.78-7.02z M154.78,39.05
					c-4.25,0-8.19-1.27-11.49-3.44l-7.82,2.1l2.07-7.73c-2.31-3.36-3.67-7.44-3.67-11.83c0-11.55,9.36-20.91,20.91-20.91
					s20.91,9.36,20.91,20.91C175.69,29.68,166.33,39.05,154.78,39.05z"
            />
          </g>
        </g>
        <g>
          <path
            class="st1"
            d="M146.95,6.49c0.98,0,1.21,0.53,1.56,1.28c0.31,0.66,1.44,3.59,1.71,4.16c0.47,0.99,0.37,1.02-0.1,1.99
				c-0.15,0.31-1.03,1.3-1.39,1.69c-0.38,0.41-0.44,0.73-0.13,1.25c1.98,3.3,4.49,5.74,8.5,7.38c0.73,0.3,0.96,0.29,1.29-0.05
				c0.32-0.35,1.55-1.87,2.12-2.62c0.44-0.57,0.94-0.43,1.36-0.26c0.37,0.15,3.98,1.91,4.86,2.32c0.78,0.36,0.74,0.52,0.74,1.18
				c0,0.5-0.19,1.86-0.61,2.59c-0.3,0.53-1.97,2.78-5.33,2.78c-1.3,0-7.26-0.74-12.41-5.63c-6.1-5.8-7.21-10.04-7.21-11.96
				c0-2.33,0.93-3.94,2.08-5.19c0.9-0.97,1.61-0.89,2.03-0.89C146.45,6.49,146.95,6.49,146.95,6.49z"
          />
        </g>
      </g>
    </g>
    <g>
      <g>
        <g>
          <path
            class="st0"
            d="M-44.64,56.83l-7.83-2.68c-0.78-0.27-1.75-0.37-3.08,0.96c-0.29,0.28-0.55,0.6-0.81,0.93
				c-0.42,0.61-1.69,2.48-1.69,2.48l-0.79,1.16L-60.06,59c-3.18-1.77-6.14-4.01-8.78-6.67c-2.65-2.64-4.9-5.61-6.68-8.78l-0.68-1.23
				l1.16-0.78c0,0,1.88-1.27,2.47-1.68c0.36-0.28,0.68-0.56,0.96-0.82c1.32-1.33,1.22-2.29,0.95-3.09l-2.67-7.82
				c-0.95-2.78-4-4.27-6.77-3.32l-2.82,0.96c-1.21,0.43-2.28,1.09-3.17,1.98c-0.57,0.56-1.06,1.22-1.43,1.92
				c-0.48,0.88-0.79,1.82-0.93,2.76c-0.14,0.84-0.14,1.68,0.01,2.5l0.1,0.43c2.02,8.64,6.77,17.17,13.04,23.45
				c6.27,6.26,14.81,11.02,23.45,13.04l0.43,0.1c0.82,0.15,1.66,0.16,2.52,0.02c0.93-0.14,1.87-0.45,2.73-0.94
				c0.72-0.37,1.36-0.85,1.94-1.42c0.89-0.89,1.55-1.97,1.97-3.19l0.96-2.81C-40.37,60.82-41.86,57.77-44.64,56.83z"
          />
        </g>
      </g>
    </g>
    <rect x="-51.93" y="-58.57" class="st0" width="25.22" height="25.22" />
    <g>
      <g>
        <path
          class="st0"
          d="M210.47,78.13c-0.98-1.48-2.65-2.45-4.55-2.45h-43.21c-1.9,0-3.57,0.98-4.55,2.45l26.16,24.21L210.47,78.13z"
        />
      </g>
      <path
        class="st0"
        d="M211.36,79.82l0.01,32.26c0,2.04-1.65,3.69-3.69,3.69h-46.74c-2.04,0-3.69-1.65-3.69-3.69l0.01-32.26
		l27.05,25.09L211.36,79.82z"
      />
    </g>
    <path
      class="st0"
      d="M41.03,50c7.63,7.71,14.32,14.66,21.31,22.98C54.02,66,46.22,58.47,38.51,50.84L37.66,50V50l0.85-0.84
	c7.71-7.63,15.5-15.16,23.82-22.14C55.35,35.34,48.66,42.29,41.03,50z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
